import axios from "axios";
/* -------------------------------------------------------------------------------------------------------------------------------------------(API URL)------------------------------------------------------------------------------------------------------------------------------------------------------------*/
const BASE_URL = 'https://youtube-v31.p.rapidapi.com'
/* -------------------------------------------------------------------------------------------------------------------------------------------(Connects to the .env file with the API KEY)------------------------------------------------------------------------------------------------------------------------------------------------------------*/
const options = {
    params: {
      maxResults: '50'
    },
    headers: {
      'X-RapidAPI-Key': process.env.REACT_APP_RAPID_API_KEY,
      'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    }
  };
/* -------------------------------------------------------------------------------------------------------------------------------------------(exports the Url)------------------------------------------------------------------------------------------------------------------------------------------------------------*/
  export const fetchFromAPI = async (url) => {
  const { data } = await axios.get(`${BASE_URL}/${url}`, options)

  return data
  }